"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NodeNames;

(function (NodeNames) {
  NodeNames["Program"] = "Program";
  NodeNames["Else"] = "Else";
  NodeNames["Condition"] = "Condition";
  NodeNames["ConditionElse"] = "ConditionElse";
  NodeNames["Include"] = "Include";
  NodeNames["List"] = "List";
  NodeNames["Text"] = "Text";
  NodeNames["Assign"] = "Assign";
  NodeNames["Global"] = "Global";
  NodeNames["Local"] = "Local";
  NodeNames["Macro"] = "Macro";
  NodeNames["MacroCall"] = "MacroCall";
  NodeNames["Interpolation"] = "Interpolation";
  NodeNames["Attempt"] = "Attempt";
  NodeNames["Recover"] = "Recover";
  NodeNames["Comment"] = "Comment";
  NodeNames["Switch"] = "Switch";
  NodeNames["SwitchCase"] = "SwitchCase";
  NodeNames["SwitchDefault"] = "SwitchDefault";
  NodeNames["Break"] = "Break";
  NodeNames["Function"] = "Function";
  NodeNames["Return"] = "Return";
  NodeNames["Compress"] = "Compress";
  NodeNames["Import"] = "Import";
  NodeNames["Stop"] = "Stop";
  NodeNames["Setting"] = "Setting";
  NodeNames["Lt"] = "Lt";
  NodeNames["Nt"] = "Nt";
  NodeNames["Rt"] = "Rt";
  NodeNames["T"] = "T";
  NodeNames["Flush"] = "Flush";
  NodeNames["Ftl"] = "Ftl";
  NodeNames["Escape"] = "Escape";
  NodeNames["NoEscape"] = "NoEscape";
  NodeNames["Visit"] = "visit";
  NodeNames["Recurse"] = "Recurse";
  NodeNames["Nested"] = "Nested";
  NodeNames["Fallback"] = "Fallback";
})(NodeNames || (NodeNames = {}));

exports.default = NodeNames;